import { logger } from '@lusha/client-logger';
import { autorun } from 'mobx';
import { flow, getRoot } from 'mobx-state-tree';
import { savedContactsAdapter } from '../../../API/adapters';
import { listsAPI } from '../../../API/listsAPI';
import { fetchContactsList } from '../../../API/showSavedContactsAPI';
import { notifyFail } from '../../../hooks/useNotification';
import Contact from '../../Contact';
export const SavedTabActions = self => ({
    afterCreate: () => {
        autorun(() => {
            if (self.initializeState) {
                if (!self.allLists.length) {
                    self.fetchLists();
                }
            }
        });
        autorun(() => {
            if (self.initializeState) {
                if (self.selectedList) {
                    self.fetchShowContactsByList();
                }
            }
        });
    },
    setIsFetchingContacts: isFetchingContacts => {
        self.isFetchingContacts = isFetchingContacts;
    },
    setInitializeState: setter => {
        self.initializeState = setter;
    },
    setRefetchAllUserLists: setter => {
        self.refetchAllUserLists = setter;
    },
    setSelectedList: selectedList => {
        self.selectedList = selectedList;
    },
    setSelectedContactId: selectedContactId => {
        self.selectedContactId = selectedContactId;
    },
    clearAllSavedContacts: () => {
        self.savedContacts.clear();
    },
    clearAllSavedCompanies: () => {
        getRoot(self).companies.clear();
    },
    setContacts: contacts => {
        self.clearAllSavedContacts();
        contacts.forEach(contact => {
            const newContact = savedContactsAdapter(contact);
            self.addSingleContact(newContact);
        });
    },
    // When not accepting company_lid, we will use fqdn,
    // In exceptional cases when fqdn is not received either - we will use the homepage_url
    getCompanyKey: company => { var _a; return (company === null || company === void 0 ? void 0 : company.companyLid) || ((_a = company === null || company === void 0 ? void 0 : company.company_lid) === null || _a === void 0 ? void 0 : _a.toString()) || (company === null || company === void 0 ? void 0 : company.fqdn) || (company === null || company === void 0 ? void 0 : company.homepage_url); },
    addSingleContact: contact => {
        if (!getRoot(self).companies.get('emptySavedTabCompany')) {
            getRoot(self).setEmptyCompany('emptySavedTabCompany');
        }
        const key = contact.contactId;
        const companyId = self.getCompanyKey(contact.company) || 'emptySavedTabCompany';
        const payload = {
            id: key,
            company: companyId,
        };
        const employee = Contact.create(payload);
        const ordinalId = -1;
        employee.setSearchV2Contact(Object.assign(Object.assign({}, contact), { ordinalId, storeCompanyKey: companyId === null || companyId === void 0 ? void 0 : companyId.toString() }), getRoot(self).user);
        self.savedContacts.set(key, employee);
        if (companyId !== 'emptySavedTabCompany') {
            self.addCompany(contact.company);
        }
    },
    addCompany: company => {
        getRoot(self).addCompany(company);
    },
    setAllLists: allLists => {
        self.allLists = allLists;
    },
    fetchLists: flow(function* fetchLists() {
        try {
            self.setIsLoaded(false);
            const { user } = getRoot(self);
            let allLists = [
                {
                    id: 'all',
                    total: 1,
                    name: 'All Contacts',
                    listKey: 'all',
                    archived: false,
                    createdAt: '2021-11-29T12:57:46.000Z',
                    accountId: String(user.accountId),
                    createdByFullName: null,
                },
            ];
            // get all lists
            const query = 'archived=false&order=desc&orderBy=createdAt&page=0&pageSize=500&type=contact&filterByViewableLists=true';
            const allUserLists = yield listsAPI.getListsOfContacts(query);
            allLists = [...allLists, ...allUserLists];
            self.setAllLists(allLists);
        }
        catch (e) {
            notifyFail('Something went wrong', {
                action: 'Try again',
                onClick: self.fetchLists,
            });
        }
        self.setIsLoaded(true);
    }),
    fetchShowContactsByList: flow(function* fetchShowContactsByList() {
        try {
            self.setIsFetchingContacts(true);
            self.clearAllSavedContacts();
            const query = '$limit=50';
            const listKey = self.selectedList === 'all' ? 'all contacts' : self.selectedList;
            const result = yield fetchContactsList(listKey, query);
            self.setContacts(result);
        }
        catch (e) {
            logger.error('Failed to fetch contacts table', e);
            notifyFail('Something went wrong', {
                action: 'Try again',
                onClick: self.fetchShowContactsByList,
            });
        }
        finally {
            self.setIsFetchingContacts(false);
            self.setShouldFetchContactsAfterBulkSearch(false);
        }
    }),
    setShouldFetchContactsAfterBulkSearch(value) {
        self.shouldFetchContactsAfterBulkSearch = value;
    },
    setIsLoaded(value) {
        self.isLoaded = value;
    },
});
